import { StudioType } from '@conversed/shared/src/central/types/studio.type';
import aiChat from '@images/home/ai-chat.png';
import aiChatBlue from '@images/home/ai-chat-blue.png';
import aiTicketDeflection from '@images/home/ai-ticket-deflection.png';
import aiTicketDeflectionPurple from '@images/home/ai-ticket-deflection-purple.png';
import suggestedEmail from '@images/home/suggested-email.png';
import suggestedEmailGreen from '@images/home/suggested-email-green.png';
import voiceAi from '@images/home/voice-ai.png';
import voiceAiOrange from '@images/home/voice-ai-orange.png';

export const STUDIO_TYPE_ICONS: Record<StudioType, string> = {
  [StudioType.CHAT_AI]: aiChat,
  [StudioType.VOICE_AI]: voiceAi,
  [StudioType.TICKET_AI]: aiTicketDeflection,
  [StudioType.EMAIL_AI]: suggestedEmail,
};

export const STUDIO_TYPE_COLORED_ICONS: Record<StudioType, string> = {
  [StudioType.CHAT_AI]: aiChatBlue,
  [StudioType.VOICE_AI]: voiceAiOrange,
  [StudioType.TICKET_AI]: aiTicketDeflectionPurple,
  [StudioType.EMAIL_AI]: suggestedEmailGreen,
};

export type StudioConfig = {
  iconSrc: string;
  // Light badge/tab background (e.g. bg-blue-50)
  iconBgClass: string;
  // Font-icon tint (e.g. text-blue-500) - metric card + studio-row icon badges
  iconColorClass: string;
  // Label / metric value text colour (e.g. text-blue-600), slightly darker
  valueColorClass: string;
  // Accent border (e.g. border-blue-300)
  borderColorClass: string;
};

/**
 * Per-studio presentation (colored icon + accent colour classes). Single source
 * shared by the home "Other studios" cards, the Studio Performance section, and
 * the top-bar studio switcher tabs - change a studio's colour here and it updates
 * everywhere.
 */
export const STUDIO_CONFIG: Record<StudioType, StudioConfig> = {
  [StudioType.CHAT_AI]: {
    iconSrc: STUDIO_TYPE_COLORED_ICONS[StudioType.CHAT_AI],
    iconBgClass: 'bg-blue-50',
    iconColorClass: 'text-blue-500',
    valueColorClass: 'text-blue-600',
    borderColorClass: 'border-blue-300',
  },
  [StudioType.TICKET_AI]: {
    iconSrc: STUDIO_TYPE_COLORED_ICONS[StudioType.TICKET_AI],
    iconBgClass: 'bg-purple-50',
    iconColorClass: 'text-purple-500',
    valueColorClass: 'text-purple-600',
    borderColorClass: 'border-purple-300',
  },
  [StudioType.EMAIL_AI]: {
    iconSrc: STUDIO_TYPE_COLORED_ICONS[StudioType.EMAIL_AI],
    iconBgClass: 'bg-green-50',
    iconColorClass: 'text-green-500',
    valueColorClass: 'text-green-600',
    borderColorClass: 'border-green-300',
  },
  [StudioType.VOICE_AI]: {
    iconSrc: STUDIO_TYPE_COLORED_ICONS[StudioType.VOICE_AI],
    iconBgClass: 'bg-orange-50',
    iconColorClass: 'text-orange-500',
    valueColorClass: 'text-orange-600',
    borderColorClass: 'border-orange-300',
  },
};
